import Vue from 'vue';
import { gsap } from 'gsap';
import { ScrollTrigger } from '../gsap-bonus/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

Vue.component('project-detail-info-component', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {

        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        if (!this.$el.hasAttribute('data-in-view-reveal')) {
            return;
        }

        if (ScrollTrigger.isInViewport(this.$el)) {
            gsap.fromTo(
                this.$el,
                {
                    autoAlpha: 0,
                    y: 40,
                },
                {
                    duration: 2,
                    autoAlpha: 1,
                    y: 0,
                    ease: 'power4.inOut',
                    delay: 0.6,
                },
            );
        }
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {

    },
});
